import { useMemo } from 'react'
import {
    UsageCostRequestParams,
    useAnalyticsApi,
    useUsageAndCostLabelsMap,
} from '../../../hooks'
import { mergeNestedObjectsStructure } from '../../../utils/mergeNestedObjectsStructure'
import { transformDataObject } from './transformDataObject'
import { NestedCheckboxGroupOptionType } from 'src/components/common'

export const useValidDataSetsOptions = (filters: UsageCostRequestParams) => {
    const { useUsageCostQuery } = useAnalyticsApi()
    const { data, isSuccess } = useUsageCostQuery(filters)
    const labelsMap = useUsageAndCostLabelsMap(filters)

    const visibleDataSets = useMemo(() => {
        if (isSuccess) {
            const transformed = transformDataObject(
                mergeNestedObjectsStructure(data.items),
                labelsMap
            )
            return cleanUpDataSets(transformed)
        }
        return []
    }, [data, isSuccess, labelsMap])

    return visibleDataSets
}

const cleanUpDataSets: (
    dataSets: NestedCheckboxGroupOptionType[]
) => NestedCheckboxGroupOptionType[] = (dataSets) => {
    return dataSets.map((dataSet) => {
        if (dataSet.value !== 'cost' || !dataSet.children) {
            return dataSet
        }

        const newChildren = dataSet.children.filter((childDataSet) => {
            return !(
                ['cost_commodity', 'cost_transport'].includes(
                    childDataSet.value
                ) && !childDataSet.children?.length
            )
        })

        return {
            ...dataSet,
            children: newChildren,
        }
    })
}
